import { Button, Grid } from "@mui/material";
import { Formik, Field, Form } from "formik";
import { TextField } from "formik-mui";

import { useTranslation } from "react-i18next";
import { APIError } from "src/types";
import { ServerErrors } from "src/components/form-components/ServerErrors";
import { ButtonGrid } from "src/components/form-components/ButtonGrid";
import { ButtonLoading } from "src/components/ButtonLoading";
import { usePasswordResetConfirmSchema } from "src/schemas/password-reset-confirm.schema";

export type PasswordResetConfirmFormData = {
  password: string;
  passwordConfirmation: string;
};

interface Props {
  onClose: () => void;
  onSubmit: (values: PasswordResetConfirmFormData) => void;
  isLoading: boolean;
  errors?: APIError[] | Error | null;
}

export function PasswordResetConfirmForm(props: Props) {
  const { t } = useTranslation();
  const validationSchema = usePasswordResetConfirmSchema();
  return render();

  function render() {
    return (
      <Formik
        initialValues={{ password: "", passwordConfirmation: "" }}
        validationSchema={validationSchema}
        onSubmit={props.onSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Field
                  component={TextField}
                  label={t("label.password")}
                  name="password"
                  type="password"
                  variant="standard"
                />
              </Grid>

              <Grid item xs={12}>
                <Field
                  component={TextField}
                  label={t("label.passwordConfirmation")}
                  name="passwordConfirmation"
                  type="password"
                  variant="standard"
                />
              </Grid>

              {props.errors && (
                <Grid item xs={12}>
                  {/* @TODO: this should handle APIError and Error differently */}
                  <ServerErrors data={props.errors as APIError[]} />
                </Grid>
              )}

              <ButtonGrid container item xs={12} sx={{ justifyContent: "flex-start" }}>
                <ButtonLoading
                  isLoading={isSubmitting || props.isLoading}
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  {t("label.submit")}
                </ButtonLoading>

                <Button variant="text" onClick={props.onClose}>
                  {t("label.cancel")}
                </Button>
              </ButtonGrid>
            </Grid>
          </Form>
        )}
      </Formik>
    );
  }
}
